var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.485 20 0 15.514 0 10C0 4.486 4.485 0 10 0C15.514 0 20 4.486 20 10C20 15.514 15.514 20 10 20Z",
    fill: "#E2E3E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.442 14.2201C11.251 14.2201 11.059 14.1471 10.913 14.0011L7.42603 10.5311C7.28503 10.3901 7.20603 10.1991 7.20603 9.99909C7.20603 9.80009 7.28503 9.60909 7.42603 9.46809L10.913 5.99609C11.206 5.70409 11.68 5.70409 11.973 5.99809C12.265 6.29209 12.264 6.76709 11.971 7.05909L9.01803 9.99909L11.971 12.9391C12.264 13.2311 12.265 13.7051 11.973 13.9991C11.827 14.1471 11.634 14.2201 11.442 14.2201Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2983065ef38eb3caaec88297f1898ec8.svg";
export { ForwardRef as ReactComponent };